<template>
    <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
        <template slot="body">
            <el-form :model="form" ref="form" label-width="150px" label-position="right">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="生成数量" prop="tagJsbm">
                            <el-input-number v-model="form.tagSl"  :min="1" label="请输入数量"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </template>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </BaseDialog>
</template>

<script>
    export default {
        name: "infoDialog",
        props: {
            infoDialogConfig: {
                type: Object,
                default: () => {
                },
            },
            infoDialogVisible: {
                type: Boolean,
                default: () => false,
            },
        },
        data() {
            return {
                form: {
                    tagBatchId: '',
                    tagApplyId: '',
                    batchNum: '',
                    tagKsbm: '',
                    tagJsbm: '',
                    tagSl:1,
                    createId: '',
                    createName: '',
                    createTime: '',
                    tagSl:1,
                },
                rules: {
                    // tagApplyId: [{
                    //     required: true,
                    //     message: "请输入标签申请ID",
                    //     trigger: "submit",
                    // },],
                    // batchNum: [{
                    //     required: true,
                    //     message: "请输入批次号",
                    //     trigger: "submit",
                    // },],
                    // tagKsbm: [{
                    //     required: true,
                    //     message: "请输入开始编码",
                    //     trigger: "submit",
                    // },],
                    // tagJsbm: [{
                    //     required: true,
                    //     message: "请输入结束编码",
                    //     trigger: "submit",
                    // },],
                    // createId: [{
                    //     required: true,
                    //     message: "请输入创建人",
                    //     trigger: "submit",
                    // },],
                    // createName: [{
                    //     required: true,
                    //     message: "请输入创建人姓名",
                    //     trigger: "submit",
                    // },],
                },
                options: [],
                dialogVisible: false,
            };
        },
        computed: {},
        mounted() {
            //this.compList = this.infoDialogConfig.compList;
            this.form.tagApplyId = this.infoDialogConfig.tagApplyId;
            if (this.infoDialogConfig.data) {
                for (const key in this.infoDialogConfig.data) {
                    for (const k in this.form) {
                        if (key === k) {
                            this.form[k] = this.infoDialogConfig.data[key];
                        }
                    }
                }
            }
        },

        methods: {
            close() {
                this.$emit("update:infoDialogVisible", false);
            },
            confirm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = JSON.parse(JSON.stringify(this.form));
                        if (params.tagBatchId) {
                            this.$api
                                .formPost("/api/major/tag/tagBatch/doModById", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        } else {
                            delete params.tagBatchId;
                            this.$api
                                .formPost("/api/major/tag/tagBatch/doSave", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        }
                    }
                });
            },

        },
    };
</script>

<style lang="scss" scoped>
    .userInfo {
        width: 240px;
        display: flex;
        flex-direction: column;
        height: 100%;

    .info {
        font-size: var(--text-size);
        display: flex;
        justify-content: space-between;
        padding: 13px 0px;
        border-bottom: 1px solid #ccc;

    .title {
        min-width: 70px;
    }
    }
    }

    .avatar-uploader {
        width: 100%;
        border: 1px dotted #ccc;
        text-align: center;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 240px;
        height: 240px;
        line-height: 240px;
        text-align: center;
    }

    .avatar {
        width: 240px;
        height: 240px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagBatch/components/infoDialog.vue